<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/mobileHome">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <h1 v-else class="sidebar-title"><span class="mw" v-html="title"></span></h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/mobileHome">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <h1 class="sidebar-title"><span class="mw" v-html="title"></span></h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      title: 'ᠣᠶᠤᠨ<br>ᠮᠡᠳᠡᠭᠡ<br>ᠵᠠᠨᠭᠭᠢ <br>ᠮᠡᠷᠭᠡᠵᠢᠯ',
      logo: require('@/assets/images/logo.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;
  background: url(../../../assets/images/draw_top_bg.png) repeat;
  height: 230px;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    display: flex;
    flex-flow: column;
    & .sidebar-logo {
      width: 40%;
      margin-top: 15%;
    }

    & .sidebar-title {
      text-align: center;
      line-height: 2;
      font-size: 2.4rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(0, 160, 233, 1);
      margin-top: 6px;
      span{
        text-align: left;
        font-family: 'OyunGarqagTig';
        padding-top: 10px;
        line-height: 1.5;
      }
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/mobieLayoutMn/components/Sidebar/Logo.vue